<template>
  <div>
    <md-list :class="`md-triple-line md-dense match-info-list match ${statusClass}`">
      <md-list-item @click="onSelect">
        <div class="match-name">{{match.name}}</div>
        <div class="md-list-item-text">
          <span>{{match.description}}</span>
          <span class="match-competitors">{{competitorsDescription}}</span>
          <md-tooltip>{{competitorsDescription}} - {{match.description}} - {{extraInfo(tournament, match)}}</md-tooltip>
          <p>
            <span>{{ extraInfo(tournament, match) }}</span>
          </p>
        </div>
        <md-button @click="edit" class="md-icon-button">
          <md-icon>{{icon(tournament, match)}}</md-icon>
        </md-button>
      </md-list-item>
    </md-list>

    <div v-if="isMine()">
      <MatchStartDialog
        v-if="isReady(tournament, match)"
        :tournament="tournament"
        :match="match"
        :show="showMatchActionDialog"
        @onClose="showMatchActionDialog = false"
      />
      <MatchEndDialog
        v-else-if="isInProgress(match)"
        :tournament="tournament"
        :match="match"
        :show="showMatchActionDialog"
        @onClose="showMatchActionDialog = false"
      />
      <UpdateMatchDialog
        :tournament="tournament"
        :match="match"
        :show="showUpdateMatchDialog"
        @onClose="showUpdateMatchDialog = false"
      />
    </div>
  </div>
</template>

<script>
import { MatchTools, TournamentTools } from "@/js/helper";
import { MatchStatus } from "@/js/models";
import MatchStartDialog from "@/components/dialogs/matchStartDialog.vue";
import MatchEndDialog from "@/components/dialogs/matchEndDialog.vue";
import UpdateMatchDialog from "@/components/dialogs/updateMatchDialog.vue";

export default {
  name: "Match",
  props: { tournament: Object, match: Object },
  components: { MatchStartDialog, MatchEndDialog, UpdateMatchDialog },
  data: function() {
    return { showMatchActionDialog: false, showUpdateMatchDialog: false };
  },
  computed: {
    competitorsDescription: {
      get() {
        return MatchTools.competitorsDescription(this.match);
      }
    },
    statusClass: {
      get() {
        if (this.isCompleted(this.match)) return MatchStatus.Completed;
        if (this.isInProgress(this.match)) return MatchStatus.InProgress;
        if (this.isReady(this.tournament, this.match)) return MatchStatus.Ready;
        return MatchStatus.NotReady;
      }
    }
  },
  methods: {
    isMine() {
      return TournamentTools.isMine(this.tournament);
    },
    isReady: MatchTools.isReady,
    isInProgress: MatchTools.isInProgress,
    isCompleted: MatchTools.isCompleted,
    extraInfo: MatchTools.extraInfo,
    icon: MatchTools.icon,
    onSelect(event) {
      if (!this.showUpdateMatchDialog) {
        this.showMatchActionDialog = true;
      }
    },
    edit(event) {
      this.showUpdateMatchDialog = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.match-name {
  padding-right: 1em;
  width: 2em;
  float: left;
  font-weight: bold;
  font-size: 2em;
  text-align: right;
}

.match-competitors {
  font-weight: bold;
  font-size: larger !important;
}

.match {
  width: 300px;
  margin: 0;
  border-radius: 2em;
  border: solid;
}
.COMPLETED {
  background-color: black !important;
}
.INPROGRESS {
  background-color: rgb(54, 73, 25) !important;
}
.READY {
  background-color: rgb(145, 75, 18) !important;
}
.NOTREADY {
  background-color: rgb(231, 95, 117) !important;
}
</style>


// WEBPACK FOOTER //
// match.vue?25f7790e